import AbrdnButton from 'components/Generic/Buttons/AbrdnButton';
import { useI18n } from 'next-localization';
import Loader from 'components/Generic/Loader';

type Props = {
  loadMore: (page: number) => void;
  isFetching: boolean;
  currentPage: number;
  maxPages: number;
  className: string;
};

const LoadMoreButton = ({ loadMore, isFetching, currentPage, maxPages, className }: Props) => {
  const { t } = useI18n();
  if (maxPages <= currentPage) return null;

  return (
    <AbrdnButton
      buttonType="primary"
      disabled={isFetching}
      className={className}
      onClick={() => loadMore(currentPage + 1)}
    >
      <span>{t('loadMore')}</span>
      {isFetching && (
        <Loader className="mt-0 ms-2" color="white" aria-hidden="true" loading={isFetching} />
      )}
    </AbrdnButton>
  );
};

export default LoadMoreButton;
